"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import { InView } from "react-intersection-observer";
import logo from "@/src/assets/images/logo.webp";
import { Tabs } from "antd";
import Image from "next/image";
import "./style.css";

import CustomHeader from "@/src/components/header/header";
import Footer from "@/src/components/footer/Footer";
import ProfileCard from "@/src/components/profileCard/ProfileCard";

import heroImage from "@/src/assets/images/aboutUs/heroImage.webp";
import adityaPic from "@/src/assets/images/aboutUs/section2/adityaRatnu.webp";
import dhruvPic from "@/src/assets/images/aboutUs/section2/dhruvBhatia.webp";
import linkedIn from "@/src/assets/images/aboutUs/linkedIn.svg";

import yashR from "@/src/assets/images/aboutUs/profiles/yashR.webp";
import srinooS from "@/src/assets/images/aboutUs/profiles/srinooS.webp";
import lakshayS from "@/src/assets/images/aboutUs/profiles/lakshayS.webp";
import sonali from "@/src/assets/images/aboutUs/profiles/sonali.webp";
import sanjay from "@/src/assets/images/aboutUs/profiles/sanjay.webp";
import akshayG from "@/src/assets/images/aboutUs/profiles/akshayG.webp";
import bharatM from "@/src/assets/images/aboutUs/profiles/bharatM.webp";
import khemeshM from "@/src/assets/images/aboutUs/profiles/khemeshM.webp";
import dipankarB from "@/src/assets/images/aboutUs/profiles/dipankarB.webp";
import namanM from "@/src/assets/images/aboutUs/profiles/namanM.webp";
import pawanK from "@/src/assets/images/aboutUs/profiles/pawanK.webp";
// import raviD from "@/src/assets/images/aboutUs/profiles/raviD.webp";
import IVRao from "@/src/assets/images/aboutUs/profiles/IVRao.webp";
import DiwakarDadoo from "@/src/assets/images/aboutUs/profiles/DiwakarDadoo.webp";
import piyushAgrawal from "@/src/assets/images/aboutUs/profiles/piyushAgrawal.webp";
import Sandeep from "@/src/assets/images/aboutUs/profiles/Sandeep.webp";
import Shivshankar from "@/src/assets/images/aboutUs/profiles/Shivshankar.webp";
import SomeshSharma from "@/src/assets/images/aboutUs/profiles/SomeshSharma.webp";
import Avinash from "@/src/assets/images/aboutUs/profiles/avinash.webp";

import memoriesGroup from "@/src/assets/images/aboutUs/memories/memoriesGroup.webp";

import slide2 from "@/src/assets/images/aboutUs/heroSlider/slide2.webp";
import slide3 from "@/src/assets/images/aboutUs/heroSlider/slide3.webp";
import slide4 from "@/src/assets/images/aboutUs/heroSlider/slide4.webp";
import slide5 from "@/src/assets/images/aboutUs/heroSlider/slide5.webp";
import slide6 from "@/src/assets/images/aboutUs/heroSlider/slide6.webp";
import Link from "next/link";

import techPartner1 from "@/src/assets/images/aboutUs/partners/technology/image1.svg";
import techPartner2 from "@/src/assets/images/aboutUs/partners/technology/image2.svg";

import financingPartner1 from "@/src/assets/images/aboutUs/partners/financing/image1.svg";
import financingPartner2 from "@/src/assets/images/aboutUs/partners/financing/image2.svg";
import financingPartner3 from "@/src/assets/images/aboutUs/partners/financing/image3.svg";
import financingPartner4 from "@/src/assets/images/aboutUs/partners/financing/image4.svg";
import financingPartner5 from "@/src/assets/images/aboutUs/partners/financing/image5.svg";
import financingPartner6 from "@/src/assets/images/aboutUs/partners/financing/image6.webp";
import financingPartner7 from "@/src/assets/images/aboutUs/partners/financing/image7.webp";

import partnerGroup from "@/src/assets/images/aboutUs/partners/partnerGroup.png";
import BrandsCard from "@/src/components/BrandsCard/BrandsCard";
import { useEffect, useState } from "react";

const onChange = (key) => {
	console.log(key);
};

const items = [
	{
		key: "1",
		label: "OUR MENTOR",
		children: (
			<div className="mentor_container">
				<div className="mentor_section">
					<ProfileCard
						imageUrl={DiwakarDadoo}
						name={"Dr. Diwakar Dadoo"}
						position={"Strategic Advisor & Mentor"}
						linkedIn={
							"https://www.linkedin.com/in/dr-diwakar-dadoo-99baa22/"
						}
					/>
					<p className="diwakar_para">
						A private Equity professional with more then 25 years of
						experience. He Mentors Entrepreneur's, across sectors &
						business stages in helping businesses grow strategically
						and exponentially that succeed & outperform. <br />
						<br />
						<span>
							<b>Degree:</b> B.Com.(Hons.), FCA, MBA (FMS) Ph.D.
							(PE & VC)
						</span>
						<br />
						<br />
						(Founding Member - Brand Capital )
					</p>
				</div>
				<div className="mentor_section">
					<ProfileCard
						imageUrl={piyushAgrawal}
						name={"Piyush Agarwal"}
						position={"Advisor"}
						linkedIn={"https://www.linkedin.com/in/iv-rao-7326a04/"}
					/>
					<p>
						A seasoned finance professional with over two decades of
						experience in the industry. He has held various
						leadership roles in renowned organizations, including
						ICICI Bank, HSBC, Gopal Sponge and Power, Maxgrow Group,
						Oneworld Group, Rank Finworld LLP, Grassroots Advisors,
						and his current position as Partner/Director at
						Nakshatra Group. His expertise spans across creating
						management tools to measure financial & operational
						performance. Additionally, he excels in business
						planning and execution. <br />
						<br />
						<span>
							<b> Degree:</b> CA, B.Com
						</span>
						<br />
						<br /> (Director in Nakshatra group - Structured Finance
						)
					</p>
				</div>
				<div className="mentor_section">
					<ProfileCard
						imageUrl={IVRao}
						name={"IV Rao"}
						position={"Mentor"}
						linkedIn={"https://www.linkedin.com/in/iv-rao-7326a04/"}
					/>
					<p>
						Has been with Maruti Suzuki for the last 31 years, in
						different roles and positions in Product Development,
						Engineering and Production Engineering functions. <br />
						<br />
						<span>
							<b>Degree:</b> B.Tech, M.Tech
						</span>
						<br />
						<br />
						(Ex Executive Advisor, Engineering & Director, Maruti
						Suzuki )
					</p>
				</div>
			</div>
		),
	},
	{
		key: "2",
		label: "OUR TEAM",
		children: (
			<div className="team_container">
				<ProfileCard
					imageUrl={Avinash}
					name={"Avinash Chopra"}
					position={"CMO | Chief Mobility Officer"}
					linkedIn={""}
				/>{" "}
				<ProfileCard
					imageUrl={akshayG}
					name={"akshay gopal sharma"}
					position={"CEO's Office"}
					linkedIn={
						"https://www.linkedin.com/in/akshay-sharma-b303211a0/"
					}
				/>{" "}
				<ProfileCard
					imageUrl={namanM}
					name={"nAMAN MALHOTRA"}
					position={"OPERATION HEAD"}
					linkedIn={
						"https://www.linkedin.com/in/naman-malhotra-25714546/"
					}
				/>{" "}
				<ProfileCard
					imageUrl={SomeshSharma}
					name={"Somesh Sharma"}
					position={"Business Development Head"}
					linkedIn={""}
				/>{" "}
				<ProfileCard
					imageUrl={Sandeep}
					name={"Sandeep"}
					position={"Asst.Zonal Manager"}
					linkedIn={""}
				/>{" "}
				<ProfileCard
					imageUrl={Shivshankar}
					name={"Shivshankar"}
					position={"Zonal Manager Pune"}
					linkedIn={""}
				/>{" "}
				<ProfileCard
					imageUrl={bharatM}
					name={"bharat mishra"}
					position={"operation ex"}
					linkedIn={
						"https://www.linkedin.com/in/bharat-mishra-a42879259/"
					}
				/>{" "}
				<ProfileCard
					imageUrl={dipankarB}
					name={"dIPANKAR BHARDWAJ"}
					position={"OPERATION EX"}
					linkedIn={
						"https://www.linkedin.com/in/dipankar-bharadwaj-8468845b/"
					}
				/>
				<ProfileCard
					imageUrl={sanjay}
					name={"Sanjay"}
					position={"cluster manager"}
					linkedIn={
						"https://www.linkedin.com/in/sanjay-sharma-396b32207/"
					}
				/>{" "}
				<ProfileCard
					imageUrl={srinooS}
					name={"Srinoo sharma"}
					position={"sourcing ex"}
					linkedIn={
						"https://linkedin.com/in/srinoo-sharma-a59216246/"
					}
				/>
				<ProfileCard
					imageUrl={lakshayS}
					name={"LAKSHAY SHARMA"}
					position={"ACCOUNTS"}
					linkedIn={
						"https://www.linkedin.com/in/lakshay-sharma-019012280/"
					}
				/>
				<ProfileCard
					imageUrl={khemeshM}
					name={"KHEMESH MEENA"}
					position={"MIS EX"}
					linkedIn={
						"https://www.linkedin.com/in/khemesh-meena-a56a5514b/"
					}
				/>{" "}
				{/* <ProfileCard
					imageUrl={raviD}
					name={"rAVI DIWAKAR"}
					position={"SR. TL"}
					linkedIn={
						"https://www.linkedin.com/in/ravi-diwakar-34499125a/"
					}
				/>{" "} */}
				<ProfileCard
					imageUrl={yashR}
					name={"Yash Rana"}
					position={"ui/ux designer Intern"}
					linkedIn={"https://www.linkedin.com/in/rana-yash11/"}
				/>
				<ProfileCard
					imageUrl={sonali}
					name={"Sonali"}
					position={"Graphic designer"}
					linkedIn={"https://www.linkedin.com/in/sonali-vashisht/"}
				/>{" "}
				<ProfileCard
					imageUrl={pawanK}
					name={"PAWAN KUMAR"}
					position={"SOCIAL MEDIA EX"}
					linkedIn={
						"https://www.linkedin.com/in/pawan-kumar-8253b6273/"
					}
				/>{" "}
			</div>
		),
	},
];

// function scaleGroup(group) {
//   var bbox = group.getBBox();
//   console.log(bbox);
//   var cx = bbox.x + bbox.width / 2;
//   var cy = bbox.y + bbox.height / 2;

//   group.setAttribute("transform", "scale(1.1)");
// }

// function resetScale(group) {
//   group.setAttribute("transform", "");
// }

function page() {
	// useEffect(() => {
	//   let hover = document.querySelectorAll(".icon_round");
	//   for (let elem of hover) {
	//     elem.addEventListener("mouseenter", () => {
	//       scaleGroup(elem);
	//     });
	//     elem.addEventListener("mouseleave", () => {
	//       resetScale(elem);
	//     });
	//   }
	// }, []);

	const handleDownload = () => {
		// Replace 'example.txt' with the path to the file you want to download
		// const filePath = "public/pdf/Company-profile.pdf";
		const filePath = "/pdf/Company-profile.pdf";

		// Create an anchor element
		const anchor = document.createElement("a");
		anchor.href = filePath;

		// Set the download attribute with the desired file name
		anchor.download = "Company-Profile.pdf";

		// Programmatically trigger a click event on the anchor element
		anchor.click();
	};
	const [script, setScript] = useState();
	useEffect(() => {
		setScript(
			JSON.stringify({
				"@context": "https://schema.org",
				"@type": "AboutPage",
				name: "Zevo India - About Us",
				url: "https://zevoindia.in/about-us",
				mainEntity: {
					"@type": "Organization",
					name: "Zevo India",
					legalName: "Zevo India Private Limited",
					foundingDate: "2017",
					description:
						"Zevo India is a leading provider of electric vehicles for sustainable deliveries in India. We offer a diverse range of eco-friendly electric two-wheelers, three-wheelers, four-wheelers, and trucks from various reputable brands.",
					url: "https://zevoindia.in",
					industry: "Transportation Industry",
					foundingLocation: {
						"@type": "Place",
						address: {
							"@type": "PostalAddress",
							addressLocality: "Delhi",
							addressRegion: "Delhi",
							addressCountry: "IN",
						},
					},
					logo: logo.src,
				},
			}),
		);
	});
	return (
		<>
			<script type="application/ld+json">{script}</script>
			<div className="about_us_page">
				<CustomHeader />
				<div className="about_us_container">
					<div className="about_us_hero_child">
						<InView>
							{({ inView, ref }) => (
								<h1
									ref={ref}
									className={inView ? "animate_about_us" : ""}
								>
									about Us
								</h1>
							)}
						</InView>
						<InView>
							{({ inView, ref }) => (
								<p
									ref={ref}
									className={inView ? "animate_about_us" : ""}
								>
									ZEVO is not just a company; it's a
									revolution in motion. As the nation's first
									dedicated EV supply chain platform, our
									mission is to redefine the industry's
									standards, driving innovation, efficiency,
									and sustainability.
								</p>
							)}
						</InView>
					</div>

					<Swiper
						autoplay={true}
						loop={true}
						modules={[Autoplay]}
						className="about_us_header_swiper"
					>
						<SwiperSlide>
							<div
								style={{
									backgroundImage: `url(${heroImage.src})`,
								}}
							></div>
						</SwiperSlide>
						<SwiperSlide>
							<div
								style={{
									backgroundImage: `url(${slide2.src})`,
								}}
							></div>
						</SwiperSlide>
						<SwiperSlide>
							<div
								style={{
									backgroundImage: `url(${slide3.src})`,
								}}
							></div>
						</SwiperSlide>
						<SwiperSlide>
							<div
								style={{
									backgroundImage: `url(${slide4.src})`,
								}}
							></div>
						</SwiperSlide>
						<SwiperSlide>
							<div
								style={{
									backgroundImage: `url(${slide5.src})`,
								}}
							></div>
						</SwiperSlide>
						<SwiperSlide>
							<div
								style={{
									backgroundImage: `url(${slide6.src})`,
								}}
							></div>
						</SwiperSlide>
					</Swiper>
				</div>
				<InView>
					{({ inView, ref }) => (
						<h3
							ref={ref}
							className={`client_heading_mobile ${
								inView ? "animate_about_us" : ""
							}`}
						>
							CLIENTS
						</h3>
					)}
				</InView>
				<BrandsCard className={"brands_card_mobile"} />
				<section className="section2">
					<div className="our_story_container">
						<div className="our_story_div">
							<InView>
								{({ inView, ref }) => (
									<h3
										ref={ref}
										className={
											inView ? "animate_about_us" : ""
										}
									>
										Our STORY
									</h3>
								)}
							</InView>
							<p>
								ZEVO, short for Zero Emission Vehicle Operation,
								was conceived in 2022 by visionary minds CA
								Aditya Singh Ratnu and CA Dhruv Bhatia. The
								inception of ZEVO stemmed from recognizing a
								critical gap in sustainable mobility solutions
								for businesses juxtaposed against the presence
								of underutilized infrastructure assets in micro
								warehousing and the inefficiencies plaguing cold
								chain logistics. United by a shared vision since
								their school days, these founders embarked on a
								mission fueled by their unwavering belief in the
								ethos, "if not us, then who?"
							</p>
						</div>
						<div className="section2_image_container">
							<div className="img1_label">
								<h4>CA ADITYA SINGH RATNU</h4>
								<div>
									<p>chief EXECUTIVE OFFICER</p>
									<Link
										rel="canonical"
										href="https://www.linkedin.com/in/aditya-singh-ratnu-66727016b/"
									>
										<Image
											src={linkedIn}
											width={25}
											height={25}
											alt="linkedin"
										/>
									</Link>
								</div>
							</div>
							<Image
								src={adityaPic}
								width={600}
								height={600}
								alt="icon"
							/>
						</div>
					</div>
					<div className="our_values_container">
						<div className="our_values_div">
							<InView>
								{({ inView, ref }) => (
									<h3
										ref={ref}
										className={
											inView ? "animate_about_us" : ""
										}
									>
										Our Values
									</h3>
								)}
							</InView>
							<p>
								Driven by a commitment to delve into the
								positive impact of electric vehicles (EVs) on
								supply chains, ZEVO sought to quantify the
								substantial CO2 offset achievable through their
								integration. Beyond environmental
								considerations, ZEVO set its sights on
								revolutionizing business operations while
								uplifting gig-workers, empowering small vendors,
								and supporting farmers.
							</p>
						</div>
						<div className="section2_image_container">
							<div className="img2_label">
								<h4>CA DHRUV BHATIA</h4>
								<div>
									<p>chief OPERATIONS OFFICER</p>
									<Link
										rel="canonical"
										href="https://www.linkedin.com/in/dhruv-bhatia-043945b7/"
									>
										<Image
											src={linkedIn}
											width={25}
											height={25}
											alt="linkedin"
										/>
									</Link>
								</div>
							</div>
							<Image
								src={dhruvPic}
								width={600}
								height={600}
								alt="icon"
							/>
						</div>
					</div>
				</section>
				<InView>
					{({ inView, ref }) => (
						<h3
							ref={ref}
							className={`client_heading ${
								inView ? "animate_about_us" : ""
							}`}
						>
							CLIENTS
						</h3>
					)}
				</InView>
				<BrandsCard />
				<section className="section3">
					<Tabs
						defaultActiveKey="1"
						items={items}
						onChange={onChange}
						rootClassName="tab_container"
					/>
					{/* <h2>Our Mentor</h2>
				<div>
					<ProfileCard
						imageUrl={DiwakarDadoo}
						name={"Dr. Diwakar Dadoo"}
						position={"Strategic Advisor & Mentor"}
						linkedIn={
							"https://www.linkedin.com/in/dr-diwakar-dadoo-99baa22/"
						}
					/>
					<ProfileCard
						imageUrl={IVRao}
						name={"IV Rao"}
						position={"Ex Executive Advisor"}
						linkedIn={"https://www.linkedin.com/in/iv-rao-7326a04/"}
					/>
				</div>
				<h2>Our Team</h2>
				<div>
					<ProfileCard
						imageUrl={namanM}
						name={"nAMAN MALHOTRA"}
						position={"OPERATION HEAD"}
						linkedIn={
							"https://www.linkedin.com/in/naman-malhotra-25714546/"
						}
					/>{" "}
					<ProfileCard
						imageUrl={akshayG}
						name={"akshay gopal sharma"}
						position={"operation manager(agri)"}
						linkedIn={
							"https://www.linkedin.com/in/akshay-sharma-b303211a0/"
						}
					/>{" "}
					<ProfileCard
						imageUrl={bharatM}
						name={"bharat mishra"}
						position={"operation ex"}
						linkedIn={
							"https://www.linkedin.com/in/bharat-mishra-a42879259/"
						}
					/>{" "}
					<ProfileCard
						imageUrl={dipankarB}
						name={"dIPANKAR BHARDWAJ"}
						position={"OPERATION EX"}
						linkedIn={
							"https://www.linkedin.com/in/dipankar-bharadwaj-8468845b/"
						}
					/>
					<ProfileCard
						imageUrl={yashR}
						name={"Yash Rana"}
						position={"ui/ux designer Intern"}
						linkedIn={"https://www.linkedin.com/in/rana-yash11/"}
					/>
					<ProfileCard
						imageUrl={srinooS}
						name={"Srinoo sharma"}
						position={"sourcing ex"}
						linkedIn={
							"https://linkedin.com/in/srinoo-sharma-a59216246/"
						}
					/>
					<ProfileCard
						imageUrl={lakshayS}
						name={"LAKSHAY SHARMA"}
						position={"ACCOUNTS"}
						linkedIn={
							"https://www.linkedin.com/in/lakshay-sharma-019012280/"
						}
					/>
					<ProfileCard
						imageUrl={sonali}
						name={"Sonali"}
						position={"Graphic designer"}
						linkedIn={
							"https://www.linkedin.com/in/sonali-vashisht/"
						}
					/>{" "}
					<ProfileCard
						imageUrl={sanjay}
						name={"Sanjay"}
						position={"cluster manager"}
						linkedIn={
							"https://www.linkedin.com/in/sanjay-sharma-396b32207/"
						}
					/>{" "}
					<ProfileCard
						imageUrl={khemeshM}
						name={"KHEMESH MEENA"}
						position={"MIS EX"}
						linkedIn={
							"https://www.linkedin.com/in/khemesh-meena-a56a5514b/"
						}
					/>{" "}
					<ProfileCard
						imageUrl={pawanK}
						name={"pAWAN KUMAR"}
						position={"SOCIAL MEDIA EX"}
						linkedIn={
							"https://www.linkedin.com/in/pawan-kumar-8253b6273/"
						}
					/>{" "}
					<ProfileCard
						imageUrl={raviD}
						name={"rAVI DIWAKAR"}
						position={"SR. TL"}
						linkedIn={
							"https://www.linkedin.com/in/ravi-diwakar-34499125a/"
						}
					/>{" "}
				</div> */}
					<Link rel="canonical" href={"/contact-us"}>
						<button>JOIN OUR TEAM</button>
					</Link>
				</section>
				<section className="section4">
					<div>
						<span>OUR </span>
						<h3>MOMENTS</h3>
					</div>
					<InView>
						{({ inView, ref }) => (
							<Image
								ref={ref}
								className={`memories_group_image ${
									inView ? "animate_about_us_image" : ""
								} `}
								src={memoriesGroup}
								width={1000}
								height={1009}
								alt="icon"
							/>
						)}
					</InView>
				</section>
				<div className="section5 technology_partner_div">
					<div>
						<span>TECHNOLOGY </span>
						<h3>PARTNERS</h3>
					</div>
					<div className="partners_card" id="tech_partners_card">
						<Image
							className="partners_card_img2"
							src={techPartner1}
							width={250}
							height={0}
							alt="partners image"
						/>
						<Image
							className="partners_card_img"
							src={techPartner2}
							width={130}
							height={0}
							alt="partners image"
						/>
					</div>
				</div>
				<div className="section5 financing_partner_div">
					<div>
						<span>FINANCING </span>
						<h3>PARTNERS</h3>
					</div>
					<div className="partners_card" id="partners_card">
						<Image
							className="partners_card_img"
							src={financingPartner1}
							width={300}
							height={0}
							alt="partners image"
						/>
						<Image
							className="partners_card_img"
							src={financingPartner2}
							width={300}
							height={0}
							alt="partners image"
						/>
						<Image
							className="partners_card_img"
							src={financingPartner3}
							width={300}
							height={0}
							alt="partners image"
						/>
						<Image
							className="partners_card_img2"
							src={financingPartner4}
							width={500}
							height={0}
							alt="partners image"
						/>
						<Image
							className="partners_card_img"
							src={financingPartner5}
							width={300}
							height={0}
							alt="partners image"
						/>
						<Image
							className="partners_card_img2  partners_card_img_long"
							src={financingPartner6}
							width={600}
							height={0}
							alt="partners image"
						/>
						<Image
							className="partners_card_img  partners_card_img_long"
							src={financingPartner7}
							width={600}
							height={0}
							alt="partners image"
						/>
					</div>
				</div>
				<section className="section5">
					<div>
						<span>MOBILITY </span>
						<h3>PARTNERS</h3>
					</div>
					<InView>
						{({ inView, ref }) => (
							<div
								className={`brand_icon_div_container ${
									inView ? "animate_about_us_image" : ""
								}`}
								ref={ref}
							>
								{/* <ReactSVG src={partnerGroup.src} /> */}
								<Image
									className="mobility_partner_img"
									src={partnerGroup}
									width={1000}
									height={0}
									alt="mobility partners"
									loading="lazy"
								/>
							</div>
						)}
					</InView>
				</section>
				<section className="section5 section6">
					<div>
						<span>DOWNLOAD</span>
						<h3>COMPANY PROFILE</h3>
					</div>
					<button
						className="download_profile_btn"
						onClick={handleDownload}
					>
						Company Profile
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width={51}
							height={51}
							viewBox="0 0 51 51"
							fill="none"
						>
							<path
								d="M25.5 34L14.875 23.375L17.85 20.2938L23.375 25.8187V8.5H27.625V25.8187L33.15 20.2938L36.125 23.375L25.5 34ZM12.75 42.5C11.5812 42.5 10.5811 42.0842 9.7495 41.2526C8.91792 40.421 8.50142 39.4202 8.5 38.25V31.875H12.75V38.25H38.25V31.875H42.5V38.25C42.5 39.4188 42.0842 40.4196 41.2526 41.2526C40.421 42.0856 39.4202 42.5014 38.25 42.5H12.75Z"
								fill="white"
							/>
						</svg>
					</button>
				</section>
				<Footer />
			</div>
		</>
	);
}

export default page;
